import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material'

import { DigitalCertificateDefaultRoutingModule} from './digital-certificate-default-routing.module';
import { MaterialModule } from '../../../../../core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { DigitalCertificateDefaultComponent } from './components/digital-certificate-default.component';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

@NgModule({
  declarations: [
  DigitalCertificateDefaultComponent,
  ],
    imports: [
        CommonModule,
        DigitalCertificateDefaultRoutingModule,
        MatTableModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SharedModule,
        NgMatAutocompleteModule,
        NgZorroAntdModule,
        Ng4LoadingSpinnerModule.forRoot()
    ],
  entryComponents: [
  ]
})
export class DigitalCertificateDefaultModule { }
